import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startAnalytics, trackPageView } from '../lib/analytics';
import { captureAttribution } from '../lib/attribution';

// 画面の切り替えごとに、Google アナリティクスへページの表示を送る（測定 ID が無いビルドでは何もしない。lib/analytics.js）。
// ページの題名は各ページが表示のあとで付けるので、少し待ってから送る。ページ内の移動（#…）だけでは送らない。
// あわせて、広告や印つきのリンクから来たときの印（gclid・utm など）を残す（lib/attribution.js。ID が無いビルドでも動く）。
const TITLE_WAIT_MS = 400;

export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    startAnalytics();
  }, []);

  useEffect(() => {
    captureAttribution();
    const timer = window.setTimeout(trackPageView, TITLE_WAIT_MS);
    return () => window.clearTimeout(timer);
  }, [pathname, search]);

  return null;
}
